import { render, staticRenderFns } from "./IaoGuides.vue?vue&type=template&id=c7701858&"
import script from "./IaoGuides.vue?vue&type=script&lang=js&"
export * from "./IaoGuides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports